import { render } from "./ParticipantsView.vue?vue&type=template&id=74e61dae&ts=true"
import script from "./ParticipantsView.vue?vue&type=script&lang=ts"
export * from "./ParticipantsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__